// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { carMakes } from '../../../types/constants'
import { SpecialRequestFormField } from '../../../types/enums'
import { enabledWhen, visibleWhen } from './common'
import { IElementProps } from '../../../types/interfaces'

const BrandsSelect = (props: IElementProps) => {
  const { t } = useTranslation('common')

  const [searchString, setSearchString] = useState('')
  const [showbrands, setShowbrands] = useState([])
  const [showAllbrands, setShowAllbrands] = useState(false)

  const optionsToRender = props.options
    ? props.options
        .filter((o) => visibleWhen(o.visibleWhen, props.data))
        .map((o) => ({
          name: o.name,
          value: o.value,
          enabledWhen: enabledWhen(o.enabledWhen, props.data),
        }))
    : carMakes.map((key) => ({
        name: key.name,
        value: key.value,
        enabledWhen: true,
      }))

  //   !!props.externalData?.data
  //     ? Object.keys(props.externalData.data).map((key) => ({
  //         name: key,
  //         value: props.externalData.data[key],
  //       }))
  //     : []

  useEffect(() => {
    if (searchString.length >= 2) {
      const found = optionsToRender.filter((c) => c.name.toLowerCase().indexOf(searchString) > -1)
      setShowbrands(found.sort())
    } else {
      setShowbrands([])
      if (showAllbrands) {
        setShowbrands(optionsToRender.sort())
      }
    }
  }, [searchString])

  function searchChanged(e: React.ChangeEvent<HTMLInputElement>) {
    setSearchString(e.target.value.toLowerCase())
  }

  function selectbrand(el: any) {
    const e = {
      target: {
        value: el.value,
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)
    setShowbrands([])
    setShowAllbrands(false)
    setSearchString('')
  }

  function removebrand() {
    const e = {
      target: {
        value: '',
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)
    setShowbrands([])
    setShowAllbrands(false)
    setSearchString('')
  }

  const brandsRef = useRef(null)

  function handleDocumentClick(e: Event) {
    if (brandsRef.current.contains(e.target)) {
      return
    } else {
      togglebrandsList(true)
    }
  }

  function togglebrandsList(close?: boolean) {
    const newState = close ? false : !showAllbrands
    const eventName = 'mousedown'
    if (!(props.formReadOnly || props.disabledInput)) {
      if (newState) {
        document.addEventListener(eventName, handleDocumentClick, false)
        setShowbrands(optionsToRender)
      } else {
        document.removeEventListener(eventName, handleDocumentClick, false)
        setShowbrands([])
        setSearchString('')
      }
      setShowAllbrands(newState)
    }
  }

  return (
    <>
      {props.visible && (
        <div style={{ position: 'relative' }} className="formGroup" ref={brandsRef}>
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <div className="selectArea">
            <input
              readOnly={props.formReadOnly || props.disabledInput}
              name={`fieldnameveryunique${new Date().getTime()}`}
              type="text"
              autoComplete="none"
              list="autocompleteOff"
              value={searchString}
              className="required-highlight transparent"
              onChange={(e) => searchChanged(e)}
              onClick={(e) => togglebrandsList()}
            />
            {props.value?.length > 0 &&
              !showAllbrands &&
              optionsToRender
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(
                  (el) =>
                    el.value === props.value && (
                      <div className="cantonsOptionInInput">
                        <div style={{ display: 'flex', gap: '5px' }}>
                          <img src={`../../../../../makesLogos/${el.value.toLowerCase()}.svg`} width="15" height="17" />
                          {el.name}
                        </div>
                        {!(props.formReadOnly || props.disabledInput) && (
                          <i onClick={(e) => removebrand()} className="icon-clear" />
                        )}
                      </div>
                    )
                )}
            <div className="cantonsOptionArea">
              {showbrands
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((el) => (
                  <a className="cantonsOption" onClick={(e) => selectbrand(el)}>
                    <img src={`../../../../../makesLogos/${el.value.toLowerCase()}.svg`} width="15" height="17" />
                    {el.name}
                  </a>
                ))}
            </div>
            <i className="icon-bottom" />
          </div>
        </div>
      )}
    </>
  )
}
export default BrandsSelect
